import React, { Component } from "react";
import ApplyToAllLocations from '../multiLocation/ApplyToAllLocations';
import { connect } from "react-redux";
import { Tabs, Tab, Modal, Dropdown } from "react-bootstrap";
import Select from "react-select";
import AddCard from "../addCardPopup/addCard";
import toast from '../shared/Toast';
import siteSetting from "../../config/env";
import { userActions, settingActions } from "../../_actions";
import { salonService,paymentService,hairdresserService } from "../../_services";
import SettingsPageLayout from './SettingsPageLayout';
import BookingQr from './BookingQr';
import Lottie from "react-lottie";
import animationData from "../../assets/animation-data/loader.json";
import { Close, Dots } from "../SvgIcon";
import './SettingsModern.css';

const selectStyles = {
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#29282D' : state.isFocused ? '#f0f0f0' : 'transparent',
        color: state.isSelected ? '#fff' : '#333',
        ':active': { backgroundColor: state.isSelected ? '#29282D' : '#e8e8e8' },
    }),
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused ? '#007EA0' : '#e0e0e0',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(0,126,160,0.08)' : 'none',
        '&:hover': { borderColor: '#ccc' },
    }),
};

const getSuggestionValue = (suggestion) => suggestion.name;

// Use your imagination to render suggestions.
const renderSuggestion = (suggestion) => <div>{suggestion.name}</div>;
const searchOptions = {
  //componentRestrictions: { country: ['GB'] },
  //types: ['city']
};
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

class BookingUrl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      salonImagePrev: require("../../assets/images/salonpic.png"),
      salonImage: "",
      salonName: "",
      allow: false,
      salonUrl: "",
      selfEmpUrl: "",
      deviceToken: "asfasfasfas",
      isShow: localStorage.getItem("isShow")=='true'?true:false,
      // Master "accept online bookings" switch. Defaults to TRUE: no salon or
      // professional carries this field yet, and absent means enabled — showing
      // it off would tell every salon they're closed. Loaded from the API in
      // loadOnlineBookingSetting() below.
      onlineBookingEnabled: true,
      // Guest bookings (clients book without an account; verified by email,
      // can pay deposits / save a card just like signed-in clients).
      // Defaults to FALSE: opt-in at launch, absent means off.
      allowGuestBooking: false,
      // OTP on guest checkout. Defaults to TRUE: absent means required; a
      // salon only skips the code step by explicitly turning it off.
      guestBookingOtpRequired: true,
      // Self-employed switches. Defaults match today's behaviour: everyone
      // shows on the salon's page, nobody has taken their own link yet.
      showOnSalonProfile: true,
      useOwnBookingLink: false,
      tradingName: '',
      tradingNameSaved: '',
      savingBrand: false,
      slugPreview: null,
      slugPreviewTaken: false,
      confirmingBrand: false,
      proPrevSlug: null,
      revertingPro: false,
      // Salon link editing (owners)
      salonLinkEditing: false,
      salonLinkName: '',
      salonLinkPreview: null,
      salonLinkPreviewTaken: false,
      confirmingSalonLink: false,
      savingSalonLink: false,
      salonPrevSlug: null,
      revertingSalon: false,
      // A professional's OWN marketplace listing, separate from the salon's.
      // Links straight to their /pro page. Defaults on — a professional is
      // discoverable unless they choose otherwise, and absent means on so
      // nobody is silently delisted.
      showOnMarketplace: true,
      proSlug: null,
      isLoader: true,
      isCopyText: false,
      noShowProtectionText: "Client does not show up",
      noShowProtectionFeePercentage: 100,
      noShowProtectionStatus: true,
      cancellationPolicies: [],
      rescheduleStatus: false,
      rescheduleBeforeHours: { value: 24, label: 'At least 24 hours before' },
      rescheduleOptions: [
        { value: 2, label: 'At least 2 hours before' },
        { value: 4, label: 'At least 4 hours before' },
        { value: 6, label: 'At least 6 hours before' },
        { value: 12, label: 'At least 12 hours before' },
        { value: 24, label: 'At least 24 hours before' },
        { value: 48, label: 'At least 48 hours before' },
        { value: 72, label: 'At least 3 days before' },
        { value: 168, label: 'At least 1 week before' },
      ],
      cancellationOptions: siteSetting?.cancellationPolicyOptions,
        onlineBookingUptoBeforeOptions:siteSetting?.onlineBookingUptoBeforeOptions,
        onlineBookingUptoOptions:siteSetting?.onlineBookingUptoOptions,
        noShowFeeChargeBy: 2,
      // noShowFeeChargeByEdit: false,
      // editCancellationPolicy: false,
      noShowChangeDetect:false,
      isShowDetect:false,
      isShowOld:null,
      cancellationChangeDetect:false,
      policyType: ["noShowProtectionFee"],
      showCardPopup:false,
      inputErrorStatus:false,
      noShowProtectionFeeError:false,
        onlineBookingUptoBefore:{value:0, label:'Anytime before appointment start time'},
        onlineBookingUpto:{value:12,  label:'No more than 12 months in advance'},
        onlineBookingUptoBeforeDefault:{value:0, label:'Anytime before appointment start time'},
        onlineBookingUptoDefault:{value:12,  label:'No more than 12 months in advance'},
    };
    // this.onChanged = this.onChanged.bind(this);
    this.checkReadOnly = this.checkReadOnly.bind(this);
    this.getCancellationPolicy = this.getCancellationPolicy.bind(this);
    this.onSavePaidBy = this.onSavePaidBy.bind(this);
  }

  componentDidMount() {
    let employmentType = {};
    var self = this;
    if (localStorage.getItem("accessToken")) {
      let params = {
        defaultRedirectTo: localStorage.getItem("defaultRedirectTo"),
      };
      this.getCancellationPolicy();
      params.latitude = siteSetting.default_latitude;
      params.longitude = siteSetting.default_longitude;
      self.props
        .dispatch(userActions.profile(params))
        .then(function (response) {
          // console.log("response", response.data.data);
          if (response.data.data) {
            if (self.props.user.userInfo.hairdresser.salon) {
              const salon = self.props.user.userInfo.hairdresser.salon;
              const hd = self.props.user.userInfo.hairdresser;
              const salonSlug = salon.slug || salon._id;
              const hairdresserId = hd.userId || hd._id;
              self.setState(
                {
                  salonUrl:
                    siteSetting.api.weburl +
                    "book/" +
                    salonSlug,
                  selfEmpUrl:
                    siteSetting.api.weburl +
                    "book/" +
                    salonSlug +
                    "/professional/" +
                    hairdresserId,
                  salonName:
                    self.props.user.userInfo.hairdresser.salon.salonName,
                  formattedAddress:
                    self.props.user.userInfo.hairdresser.salon.formattedAddress,
                  administrativeAreaLevel1:
                    self.props.user.userInfo.hairdresser.salon
                      .administrativeAreaLevel1,
                  administrativeAreaLevel2:
                    self.props.user.userInfo.hairdresser.salon
                      .administrativeAreaLevel2,
                  countryLongName:
                    self.props.user.userInfo.hairdresser.salon.countryLongName,
                  countryShortName:
                    self.props.user.userInfo.hairdresser.salon.countryShortName,
                  latitude: self.props.user.userInfo.hairdresser.salon.loc[1],
                  longitude: self.props.user.userInfo.hairdresser.salon.loc[0],
                  salonId: self.props.user.userInfo.hairdresser.salon._id,
                  isShow: self.props.user.userInfo.hairdresser.salon.isShow,
                    isShowOld:self.props.user.userInfo.hairdresser.salon.isShow,
                  postalCode:
                    self.props.user.userInfo.hairdresser.salon.postalCode,
                  salonImagePrev: self.props.user.userInfo.hairdresser.salon
                    .imageUrl
                    ? self.props.user.userInfo.hairdresser.salon.imageUrl
                    : require("../../assets/images/salonpic.png"),
                },
                function () {
                  self.setState({
                    isLoader: false,
                  });
                  self.loadOnlineBookingSetting();
                }
              );
            }
          } else {
            self.props.history.push("/");
          }
        })
        .catch((err) => {
          self.props.history.push("/");
        });
    } else {
      self.props.history.push("/");
    }
  }

  toggleChange = () => {
    this.setState({
      isShow: !this.state.isShow,
    }, () => this.updateSalon());
  };

  // Is this user setting the business's switch or their OWN?
  // Owners speak for the business; everyone else only for themselves.
  isSalonOwner = () => this.props.user?.userInfo?.hairdresser?.isSalonOwner === 1;

  /* Copy says the business's actual name wherever it can. "Salon" is wrong
     for the barbershops and other venues on Beu now, and naming the place
     reads warmer than any generic word we could pick. "the business" is only
     the fallback for the brief window before the profile has loaded. */
  businessName = () => this.state.salonName || 'the business';

  // Read the current value from the endpoints that actually return it, rather
  // than the cached redux profile — which predates the field.
  loadOnlineBookingSetting = () => {
    const self = this;

    if (this.isSalonOwner()) {
      const salonId = this.props.user?.userInfo?.hairdresser?.salon?._id;
      if (!salonId) return;
      salonService.getBookingLink(salonId)
        .then((response) => {
          const d = response?.data?.responseData;
          if (d) self.setState({ salonPrevSlug: d.previousSlug || null });
        })
        .catch(() => {});
      salonService.getSalonSettings(salonId)
        .then((response) => {
          // The salon settings endpoint nests the fields one level deeper
          // (responseData.data) than the SE profile endpoint (responseData).
          // Reading the wrong level left both toggles undefined → they fell
          // back to defaults, so allowGuestBooking always showed OFF even when
          // saved ON.
          const rd = response?.data?.responseData;
          const data = (rd && rd.data) || rd;
          if (!data) return;
          const next = {};
          if (data.onlineBookingEnabled !== undefined) next.onlineBookingEnabled = data.onlineBookingEnabled !== false;
          if (data.allowGuestBooking !== undefined) next.allowGuestBooking = data.allowGuestBooking === true;
          if (data.guestBookingOtpRequired !== undefined) next.guestBookingOtpRequired = data.guestBookingOtpRequired !== false;
          if (Object.keys(next).length) self.setState(next);
        })
        .catch((err) => console.log('Could not load salon booking setting', err));
      return;
    }

    hairdresserService.getProfileV2()
      .then((response) => {
        const data = response?.data?.responseData;
        if (!data) return;
        const next = {};
        if (data.onlineBookingEnabled !== undefined) next.onlineBookingEnabled = data.onlineBookingEnabled !== false;
        if (data.allowGuestBooking !== undefined) next.allowGuestBooking = data.allowGuestBooking === true;
        if (data.guestBookingOtpRequired !== undefined) next.guestBookingOtpRequired = data.guestBookingOtpRequired !== false;
        if (data.showOnSalonProfile !== undefined) next.showOnSalonProfile = data.showOnSalonProfile !== false;
        if (data.useOwnBookingLink !== undefined) next.useOwnBookingLink = data.useOwnBookingLink === true;
        if (data.showOnMarketplace !== undefined) next.showOnMarketplace = data.showOnMarketplace !== false;
        if (data.slug !== undefined) next.proSlug = data.slug;
        if (data.tradingName !== undefined) { next.tradingName = data.tradingName || ''; next.tradingNameSaved = data.tradingName || ''; }
        if (data.previousSlug !== undefined) next.proPrevSlug = data.previousSlug;
        if (Object.keys(next).length) self.setState(next);
      })
      .catch((err) => console.log('Could not load professional booking setting', err));
  };

  /* A professional's own marketplace listing. Distinct from the salon's
     listing above (isShow / toggleChange), which only an owner controls: this
     one puts the professional in the marketplace in their own right, linking
     to their own page rather than the salon's. */
  toggleMarketplaceListing = () => {
    const next = !this.state.showOnMarketplace;
    const previous = this.state.showOnMarketplace;
    const self = this;

    this.setState({ showOnMarketplace: next }, () => {
      hairdresserService.updateProfileV2({ showOnMarketplace: next })
        .then((response) => {
          if (response?.data?.errorCode) {
            self.setState({ showOnMarketplace: previous });
            toast.error(response.data.messages || 'Could not save. Please try again.');
            return;
          }
          toast.success(next ? "You'll appear in the Beu marketplace" : "You've been removed from the Beu marketplace");
        })
        .catch((err) => {
          console.log('Failed to update marketplace listing', err);
          self.setState({ showOnMarketplace: previous });
          toast.error('Could not save. Please try again.');
        });
    });
  };

  /* Where clients find this professional. The two underlying flags allow four
     combinations, two of which are nonsense — including "not on the salon page
     AND no own link", which leaves someone silently unbookable. Presenting it
     as one choice of two modes makes the invalid states unreachable.

       salon:       listed on the salon's page, books under the salon link
       independent: own page and own link, not listed on the salon's page

     Both flags are written together so the pair can never drift apart. */
  bookingMode = () => (this.state.useOwnBookingLink && !this.state.showOnSalonProfile ? 'independent' : 'salon');

  setBookingMode = (mode) => {
    if (this.bookingMode() === mode) return;
    const independent = mode === 'independent';
    const previous = { useOwnBookingLink: this.state.useOwnBookingLink, showOnSalonProfile: this.state.showOnSalonProfile };
    const self = this;

    this.setState({ useOwnBookingLink: independent, showOnSalonProfile: !independent }, () => {
      hairdresserService.updateProfileV2({ useOwnBookingLink: independent, showOnSalonProfile: !independent })
        .then((response) => {
          if (response?.data?.errorCode) {
            self.setState(previous);
            toast.error(response.data.messages || 'Could not save. Please try again.');
            return;
          }
          // The server mints a slug the first time someone goes independent.
          const data = response?.data?.responseData;
          if (data && data.slug) self.setState({ proSlug: data.slug });
          else if (independent) self.loadOnlineBookingSetting();
          toast.success(independent ? 'You now have your own booking page' : "You're listed with the rest of the team");
        })
        .catch((err) => {
          console.log('Failed to update booking mode', err);
          self.setState(previous);
          toast.error('Could not save. Please try again.');
        });
    });
  };

  // Debounced availability check while they type: shows the link the brand
  // would produce, and warns when the natural form is taken by someone else.
  previewBrand = (value) => {
    clearTimeout(this._brandPreviewTimer);
    const trimmed = (value || '').trim();
    if (!trimmed || trimmed === (this.state.tradingNameSaved || '').trim()) {
      this.setState({ slugPreview: null, slugPreviewTaken: false });
      return;
    }
    const self = this;
    this._brandPreviewTimer = setTimeout(() => {
      hairdresserService.previewBrandSlug(trimmed)
        .then((response) => {
          const data = response?.data?.responseData;
          // Ignore stale responses — only apply if the input hasn't moved on.
          if (data && (self.state.tradingName || '').trim() === trimmed) {
            self.setState({ slugPreview: data.slug || null, slugPreviewTaken: !!data.taken });
          }
        })
        .catch(() => {});
    }, 350);
  };

  revertProSlug = () => {
    const self = this;
    this.setState({ revertingPro: true });
    hairdresserService.revertBrandSlug()
      .then((response) => {
        const d = response?.data?.responseData;
        if (response?.data?.errorCode || !d) {
          toast.error(response?.data?.messages || 'Could not revert. Please try again.');
          self.setState({ revertingPro: false });
          return;
        }
        self.setState({
          revertingPro: false, proSlug: d.slug, proPrevSlug: d.previousSlug || null,
          tradingName: d.tradingName !== undefined ? d.tradingName : self.state.tradingName,
          tradingNameSaved: d.tradingName !== undefined ? d.tradingName : self.state.tradingNameSaved,
          slugPreview: null, slugPreviewTaken: false
        });
        toast.success('Your previous link has been restored.');
      })
      .catch(() => { toast.error('Could not revert. Please try again.'); self.setState({ revertingPro: false }); });
  };

  // Salon link handlers (owner only) — mirror the pro flow.
  previewSalonLink = (value) => {
    clearTimeout(this._salonPreviewTimer);
    const trimmed = (value || '').trim();
    const salonId = this.state.salonId;
    if (!trimmed || !salonId) { this.setState({ salonLinkPreview: null, salonLinkPreviewTaken: false }); return; }
    const self = this;
    this._salonPreviewTimer = setTimeout(() => {
      salonService.previewBookingLink(salonId, trimmed)
        .then((response) => {
          const d = response?.data?.responseData;
          if (d && (self.state.salonLinkName || '').trim() === trimmed) {
            self.setState({ salonLinkPreview: d.slug || null, salonLinkPreviewTaken: !!d.taken });
          }
        })
        .catch(() => {});
    }, 350);
  };

  saveSalonLink = () => {
    const self = this;
    const salonId = this.state.salonId;
    const name = (this.state.salonLinkName || '').trim();
    if (!salonId || !name) return;
    this.setState({ savingSalonLink: true });
    salonService.updateBookingLink(salonId, name)
      .then((response) => {
        const d = response?.data?.responseData;
        if (response?.data?.errorCode || !d) {
          toast.error(response?.data?.messages || 'Could not save. Please try again.');
          self.setState({ savingSalonLink: false, confirmingSalonLink: false });
          return;
        }
        self.setState({
          savingSalonLink: false, confirmingSalonLink: false, salonLinkEditing: false,
          salonLinkName: '', salonLinkPreview: null, salonLinkPreviewTaken: false,
          salonUrl: siteSetting.api.weburl + 'book/' + d.slug,
          salonPrevSlug: d.previousSlug || self.state.salonPrevSlug
        });
        toast.success('Booking link updated. Your old link still works.');
      })
      .catch(() => { toast.error('Could not save. Please try again.'); self.setState({ savingSalonLink: false, confirmingSalonLink: false }); });
  };

  revertSalonLink = () => {
    const self = this;
    const salonId = this.state.salonId;
    if (!salonId) return;
    this.setState({ revertingSalon: true });
    salonService.revertBookingLink(salonId)
      .then((response) => {
        const d = response?.data?.responseData;
        if (response?.data?.errorCode || !d) {
          toast.error(response?.data?.messages || 'Could not revert. Please try again.');
          self.setState({ revertingSalon: false });
          return;
        }
        self.setState({
          revertingSalon: false,
          salonUrl: siteSetting.api.weburl + 'book/' + d.slug,
          salonPrevSlug: d.previousSlug || null
        });
        toast.success('Your previous link has been restored.');
      })
      .catch(() => { toast.error('Could not revert. Please try again.'); self.setState({ revertingSalon: false }); });
  };

  saveBrand = () => {
    const self = this;
    const tradingName = (this.state.tradingName || '').trim();
    this.setState({ savingBrand: true, confirmingBrand: false });
    hairdresserService.updateProfileV2({ tradingName })
      .then((response) => {
        if (response?.data?.errorCode) {
          toast.error(response.data.messages || 'Could not save. Please try again.');
          self.setState({ savingBrand: false });
          return;
        }
        const data = response?.data?.responseData;
        const next = { savingBrand: false, tradingNameSaved: tradingName, slugPreview: null, slugPreviewTaken: false };
        // The server re-mints the slug from the brand; the old link keeps working.
        if (data && data.updated && data.updated.slug) {
          if (self.state.proSlug && data.updated.slug !== self.state.proSlug) next.proPrevSlug = self.state.proSlug;
          next.proSlug = data.updated.slug;
        }
        self.setState(next);
        toast.success('Brand saved. Your link has been updated.');
      })
      .catch(() => {
        toast.error('Could not save. Please try again.');
        self.setState({ savingBrand: false });
      });
  };

  // The professional's own link, once they have a slug.
  proBookingUrl = () =>
    this.state.proSlug ? `${siteSetting.api.weburl}book/pro/${this.state.proSlug}` : null;

  // Which link to show in the box at the top. Owners always get the salon's.
  // A professional gets their own only once they've switched to it AND a slug
  // exists — otherwise fall back to the salon-scoped link, which always works.
  primaryBookingUrl = () => {
    if (this.isSalonOwner()) return this.state.salonUrl;
    if (this.state.useOwnBookingLink && this.proBookingUrl()) return this.proBookingUrl();
    return this.state.selfEmpUrl;
  };

  toggleOnlineBooking = () => {
    const next = !this.state.onlineBookingEnabled;
    const previous = this.state.onlineBookingEnabled;
    const self = this;

    // Optimistic, but reverted on failure — this switch decides whether the
    // salon takes money, so it must never LOOK saved when it isn't.
    this.setState({ onlineBookingEnabled: next }, () => {
      const onError = (err) => {
        console.log('Failed to update online booking setting', err);
        self.setState({ onlineBookingEnabled: previous });
        toast.error('Could not update online bookings. Please try again.');
      };

      if (self.isSalonOwner()) {
        const data = new FormData();
        data.append('salonId', self.state.salonId);
        data.append('onlineBookingEnabled', next);
        salonService.updateSalon(data)
          .then((response) => {
            if (response?.data?.errorCode) return onError(response.data.messages);
            toast.success(next ? 'Online bookings turned on' : 'Online bookings turned off');
          })
          .catch(onError);
        return;
      }

      hairdresserService.updateProfileV2({ onlineBookingEnabled: next })
        .then((response) => {
          if (response?.data?.errorCode) return onError(response.data.messages);
          toast.success(next ? 'Online bookings turned on' : 'Online bookings turned off');
        })
        .catch(onError);
    });
  };

  // Guest booking (GUEST-BOOKING-PLAN.md). Off by default at launch: nothing
  // changes for a salon until they choose it. Same optimistic-with-revert
  // save as the master switch, and the same salon-vs-professional split.
  toggleGuestBooking = () => {
    const next = !this.state.allowGuestBooking;
    const previous = this.state.allowGuestBooking;
    const self = this;

    this.setState({ allowGuestBooking: next }, () => {
      const onError = (err) => {
        console.log('Failed to update guest booking setting', err);
        self.setState({ allowGuestBooking: previous });
        toast.error('Could not update guest bookings. Please try again.');
      };

      if (self.isSalonOwner()) {
        const data = new FormData();
        data.append('salonId', self.state.salonId);
        data.append('allowGuestBooking', next);
        salonService.updateSalon(data)
          .then((response) => {
            if (response?.data?.errorCode) return onError(response.data.messages);
            toast.success(next ? 'Guest bookings turned on' : 'Guest bookings turned off');
          })
          .catch(onError);
        return;
      }

      hairdresserService.updateProfileV2({ allowGuestBooking: next })
        .then((response) => {
          if (response?.data?.errorCode) return onError(response.data.messages);
          toast.success(next ? 'Guest bookings turned on' : 'Guest bookings turned off');
        })
        .catch(onError);
    });
  };

  // OTP on guest checkout — SALON-level only (the friction decision belongs
  // to the shop; SE links follow their salon). Owner-only row in the UI.
  // Same salon-vs-professional split as toggleGuestBooking above: an owner
  // sets the SALON's OTP rule (them + employed staff); a professional sets
  // their OWN (governs bookings with them).
  toggleGuestOtp = () => {
    const next = !this.state.guestBookingOtpRequired;
    const previous = this.state.guestBookingOtpRequired;
    const self = this;

    this.setState({ guestBookingOtpRequired: next }, () => {
      const onError = () => {
        self.setState({ guestBookingOtpRequired: previous });
        toast.error('Could not update the verification setting. Please try again.');
      };
      const onDone = (response) => {
        if (response?.data?.errorCode) return onError();
        toast.success(next ? 'Guests will verify with a code' : 'Verification code turned off for guests');
      };
      if (self.isSalonOwner()) {
        const data = new FormData();
        data.append('salonId', self.state.salonId);
        data.append('guestBookingOtpRequired', next);
        salonService.updateSalon(data).then(onDone).catch(onError);
        return;
      }
      hairdresserService.updateProfileV2({ guestBookingOtpRequired: next }).then(onDone).catch(onError);
    });
  };
 
  clip = (event) => {
    event.target.select();
    navigator.clipboard.writeText(this.state.salonUrl);
  };

  copyUrl = (url) => {
    //event.target.select();
    navigator.clipboard.writeText(url);
    this.setState({
      isCopyText: true,
    });
  };

  updateSalon=()=> {
    this.setState({
      error: "",
    });
    let self = this;

      let data = new FormData();
      data.append("salonId", this.state.salonId);
      data.append("salonName", this.state.salonName);
      data.append("formattedAddress", this.state.formattedAddress);
      data.append("latitude", parseFloat(this.state.latitude));
      data.append("longitude", parseFloat(this.state.longitude));
      data.append("countryShortName", this.state.countryShortName);
      data.append("countryLongName", this.state.countryLongName);
      data.append("postalCode", this.state.postalCode);
      data.append(
        "administrativeAreaLevel1",
        this.state.administrativeAreaLevel1
      );
      data.append(
        "administrativeAreaLevel2",
        this.state.administrativeAreaLevel2
      );
      data.append("deviceToken", this.state.deviceToken);
      // data.append("image", this.state.salonImage);
      data.append("isShow", this.state.isShow);

      salonService
        .updateSalon(data)
        .then(function (response) {
          console.log("client response", response);

          if (response.data.errorCode) {
            if (response.data.errorCode == 51) {
              self.setState({
                salonNameError: response.data.messages,
              });
            } else {
              self.setState({
                error: response.data.messages,
              });
            }
          } else {
            localStorage.setItem("isShow", self.state.isShow);
            //self.props.history.push('/setting')
            self.setState({
                isShowDetect:false,
                isShowOld:self.state.isShow,
              successMessage: "Your settings have been updated successfully!",
            });
              toast.success("Your settings have been updated successfully!");
          }
        })
        .catch((err) => {
          console.log("errr", err);
          //dispatch(failure(err));
        });
    // }
  }

  // gotoHome = () => {
  //   this.props.history.push("/diary/" + localStorage.getItem("salonId"));
  // };


  checkReadOnly() {
    //console.log("this.props.user.userInfo.hairdresser.isSalonOwner",this.props.user.userInfo.hairdresser.isSalonOwner)
    if (
      this.props.user &&
      this.props.user.userInfo &&
      this.props.user.userInfo.hairdresser.isSalonOwner === 1
    ) {
      return true;
    } else {
      return false;
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("setting-temps-pages");
  }

  getCancellationPolicy = () => {
    let self = this;
    let params = {
      isActiveIntend: 0,
    };

    self.props
      .dispatch(settingActions.getCancellationPolicy(params))
      .then((policyData) => {
      const responsePolicyData = policyData?.data?.responseData?.result[0];
      const noShowStatusData = responsePolicyData?.noShowStatus == 1 ? true : false;
        let updatedArr = responsePolicyData?.cancellationPolicy?.map((item) => {
          item.selectedOption = self?.state?.cancellationOptions.find(
            (option) => option.value == item.beforeBookingHour
          );
          return item;
        });
          let onlineBookingUptoBefore=self.state.onlineBookingUptoBeforeOptions?.find((item)=>{
             if(item.value == responsePolicyData?.onlineBookingUptoBefore){
                 return item
             }
        })
          let onlineBookingUpto=self.state.onlineBookingUptoOptions?.find((item)=>{
              if(item.value == responsePolicyData?.onlineBookingUpto){
                  return item
              }
          })


          self.setState({
          cancellationPolicies: updatedArr?.length>0?updatedArr:[],
          noShowProtectionFeePercentage:
            responsePolicyData?.noShowFeeInPercentage
              ? responsePolicyData?.noShowFeeInPercentage
              : 100,
          noShowFeeChargeBy: responsePolicyData?.noShowFeePaidBy?responsePolicyData?.noShowFeePaidBy:self.state.noShowFeeChargeBy,
          noShowProtectionStatus:noShowStatusData,
          rescheduleStatus: responsePolicyData?.rescheduleStatus == 1,
          rescheduleBeforeHours: self.state.rescheduleOptions.find((o) => o.value == (responsePolicyData?.rescheduleBeforeHours != null ? responsePolicyData.rescheduleBeforeHours : 24)) || { value: responsePolicyData?.rescheduleBeforeHours, label: `At least ${responsePolicyData?.rescheduleBeforeHours} hours before` },
            onlineBookingUptoBefore:onlineBookingUptoBefore?onlineBookingUptoBefore:{value:0,label:'Anytime before appointment start time'},
            onlineBookingUpto:onlineBookingUpto?onlineBookingUpto:{value:12,label:'No more than 12 months in advance'},
              onlineBookingUptoDefault:onlineBookingUpto?onlineBookingUpto:{value:12,label:'No more than 12 months in advance'},
              onlineBookingUptoBeforeDefault:onlineBookingUptoBefore?onlineBookingUptoBefore:{value:0,label:'Anytime before appointment start time'},
        });
        localStorage.setItem('noShowStatus',noShowStatusData);
      });

  };

  onChangeSetting=(e,type)=>{
      let self = this;
      self.setState({
          [type]:e,
      }, () => self.autoSavePolicies());
  }

  onChangePolicy = (selectedItem, input, type) => {
    let self = this;
    let dataValue = input?.value === undefined ? input?.target?.value : input;
    let inputErrorStatus = false;
    if(self.state.cancellationPolicies?.length>1 && type==='cancellationPolicySelect'){
      let filterInCludedData = self.state.cancellationPolicies.filter(item=>item?.beforeBookingHour==dataValue?.value);
      if(filterInCludedData?.length>0){
        self.setState({
          inputErrorStatus:true,
        })
        inputErrorStatus= true;
        toast.error("Option already selected.");
      }
    
    }

   

    let updatedData = self.state.cancellationPolicies.map((item) => {
      if (item?._id == selectedItem._id) {
        if (dataValue?.value == undefined) {
            dataValue = dataValue===''?'':+dataValue;
            item.amountInPercentage = dataValue;
        } else {
          item.selectedOption = inputErrorStatus?null:dataValue;
          item.beforeBookingHour = dataValue?.value;
        }
      }
      return item;
    });

    self.setState({
      cancellationPolicies: [...updatedData],
      policyType:type,
      cancellationChangeDetect:true,
    });
  };

 addCancellationRow = () => {
    let self = this;
    let optionContent = {
      _id: self.state.cancellationPolicies?.length - 1 + 1,
    };

    if(!this.isPolicyValidate()){
      return;
    }
   

    self.setState({
      cancellationPolicies: [...self.state.cancellationPolicies, optionContent],
    });
  };


 isPolicyValidate = () =>{
  let self = this;
  let updatedValidation =[];
  let valueErrorArr = self.state.cancellationPolicies.map(
    (item) =>{
        if(item.beforeBookingHour <= 0 ||
          item?.amountInPercentage <= 0 ||
          item.beforeBookingHour === undefined ||
          item?.amountInPercentage === undefined ||
          item?.amountInPercentage > +100 
        ){
            updatedValidation.push(item);
            if(item.beforeBookingHour === undefined){
              toast.error("Please select client cancels online.");
            }
            console.log("item",item);
            if(item?.amountInPercentage === undefined || item?.amountInPercentage === ""||
                item?.amountInPercentage > 100 ||item?.amountInPercentage <=0 ){
                toast.error("Please input valid percentage amount.");
            }
            item.errorStatus= true;
            return item;
          }else{
            item.errorStatus= false;
            return item;
          }
    });

    self.setState({
      cancellationPolicies:valueErrorArr,
    })


    if(self.state.noShowProtectionFeePercentage>100){
      toast.error("Please input valid percentage amount.");
      self.setState({
        noShowProtectionFeeError:true
      })
      return false;
     }else{
      self.setState({
        noShowProtectionFeeError:false
      })
     }
// console.log("item",updatedValidation);
  if (updatedValidation?.length > 0) {
    //toast.error("Please select client cancels online.");
    return false;
  }else{
    return true;
  }
 }

  autoSavePolicies = () => {
    let self = this;
    let params = {};

    params.noShowPolicy = {
      noShowFeeInPercentage: self.state.noShowProtectionFeePercentage,
      noShowStatus: self.state?.noShowProtectionStatus ? 1 : 0,
    };

    params.onlineBookingUptoBefore = self.state.onlineBookingUptoBefore.value;
    params.onlineBookingUpto = self.state.onlineBookingUpto.value;

    params.cancellationPolicies = self.state.cancellationPolicies?.map((policyData) => {
      return { amountInPercentage: policyData?.amountInPercentage, beforeBookingHour: policyData?.beforeBookingHour };
    });

    params.reschedulePolicy = {
      rescheduleStatus: self.state.rescheduleStatus ? 1 : 0,
      rescheduleBeforeHours: self.state.rescheduleBeforeHours?.value,
    };

    self.props
      .dispatch(settingActions.updateCancellationPolicy(params))
      .then((policyData) => {
        if (policyData?.data?.statusCode == 1) {
          toast.success(policyData?.data.responseData?.message);
        }
      })
      .catch((err) => {
        toast.error(err.messages);
      });
  };

  updateCancellationPolicy = () => {
    let self = this;
    let params = {};

    if(!this.isPolicyValidate()){
      return;
    }

     params.noShowPolicy = {
      noShowFeeInPercentage:self.state.noShowProtectionFeePercentage,
      noShowStatus:self.state?.noShowProtectionStatus ? 1 : 0,
     }

      params.onlineBookingUptoBefore=self.state.onlineBookingUptoBefore.value;
          params.onlineBookingUpto=self.state.onlineBookingUpto.value;

     params.cancellationPolicies = self.state.cancellationPolicies?.map((policyData)=>{
            return {amountInPercentage:policyData?.amountInPercentage,beforeBookingHour:policyData?.beforeBookingHour};
        })
    
    self.props
      .dispatch(settingActions.updateCancellationPolicy(params))
      .then((policyData) => {
        // console.log("update policy data", policyData);
        if (policyData?.data?.statusCode == 1) {
          self.setState({
            // editCancellationPolicy: false,
            // noShowFeeChargeByEdit:false,
            noShowChangeDetect:false,
            cancellationChangeDetect:false,
          });
          toast.success(policyData?.data.responseData?.message);
          this.getCancellationPolicy();
        }
      })
      .catch((err) => {
        toast.error(err.messages);
      });
  };


  deleteCancellationPolicy = (item) => {
    let self = this;
    let filteredData = self.state.cancellationPolicies.filter(
      (policyData) =>policyData?._id!=item._id);
      self.setState({
        cancellationPolicies: filteredData,
         cancellationChangeDetect:true
      });

  };



  onChangeProtectionFee = (type, value) => {
    let self = this;
    if (type === "status") {
        self.setState({
          noShowProtectionStatus: value,
        }, () => self.autoSavePolicies());
        let noShowStatus = value?true:false;
        localStorage.setItem('noShowStatus',noShowStatus);
    }
    if (type === "percentage") {
      self.setState({
        noShowProtectionFeePercentage: value,
      });
    }

    self.setState({
      policyType: [...this.state?.policyType, "noShowProtectionFee"],
    });
  };

  onBlurProtectionFee = () => {
    this.autoSavePolicies();
  };

  noChangePaidBy = (data) => {
    let self = this;
    self.setState({
      noShowFeeChargeBy: data,
    }, () => self.onSavePaidBy());
  };

  onSavePaidBy = () => {
    let self = this;
    let params = {
      noShowFeePaidBy: self?.state?.noShowFeeChargeBy,
    };

    self.props
      .dispatch(settingActions.updateNoShowProtectionFee(params))
      .then((policyData) => {
        if (policyData?.data?.statusCode == 1) {
          toast.success(policyData?.data.responseData?.message);
        }
      })
      .catch((err) => {
        toast.error(err.messages);
      });
  };


 resetCancellationChanges = () => {
   this.getCancellationPolicy();
   this.setState({
    cancellationChangeDetect: false,
   });
 }

  render() {
    const hasCancellationChanges = this.state.cancellationChangeDetect;

    return (
      <SettingsPageLayout activeTab="booking-url" {...this.props}>
          {/* Self-employed only: where clients find them. Owners are excluded —
              their brand IS the salon. One choice rather than two toggles, so
              the contradictory combinations simply don't exist. */}
          {!this.isSalonOwner() && (
              <div className="settings-card">
                  <div className="settings-card-header">
                      <h2>Your booking page</h2>
                      {/* Both modes land a client on THIS professional's own
                          page — the link never drops them on the salon's team
                          list. What changes is whether that page sits inside
                          the salon's or stands on its own. */}
                      <p>Your link always opens your own page. Choose whether it sits within {this.businessName()} or stands on its own.</p>
                  </div>

                  <div className="bu-modes">
                      {[
                          {
                              id: 'salon',
                              title: `Part of ${this.businessName()}`,
                              desc: "You're listed with the rest of the team, and your page sits within the main booking page.",
                          },
                          {
                              id: 'independent',
                              title: 'Independent',
                              desc: "Your page stands on its own, under your own name, and you're not listed with the team.",
                          },
                      ].map((mode) => {
                          const active = this.bookingMode() === mode.id;
                          return (
                              <button
                                  key={mode.id}
                                  type="button"
                                  className={`bu-mode${active ? ' is-active' : ''}`}
                                  onClick={() => this.setBookingMode(mode.id)}
                                  aria-pressed={active}
                              >
                                  <span className="bu-mode-radio" aria-hidden />
                                  <span className="bu-mode-text">
                                      <span className="bu-mode-title">{mode.title}</span>
                                      <span className="bu-mode-desc">{mode.desc}</span>
                                  </span>
                              </button>
                          );
                      })}
                  </div>

                  {/* The link itself lives in the card at the top, which already
                      shows whichever one is live. Repeating it here was the
                      duplicate. Only the reassurance is worth saying twice. */}
                  {this.bookingMode() === 'independent' && (
                      <>
                      <div style={{ marginTop: 16 }}>
                          <label style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>Your brand</label>
                          <p className="bu-hint" style={{ marginTop: 0, marginBottom: 8 }}>
                              Shown as your page name and used for your link. Including your area helps
                              clients find you in search, for example “Jim Bean Hair Epsom”.
                          </p>
                          <div className="bu-clipboard" style={{ marginBottom: 0 }}>
                              <input
                                  type="text"
                                  value={this.state.tradingName}
                                  maxLength={80}
                                  placeholder="e.g. Jim Bean Hair Epsom"
                                  onChange={(e) => { this.setState({ tradingName: e.target.value }); this.previewBrand(e.target.value); }}
                                  style={{ background: '#fff', color: '#333' }}
                              />
                              <button
                                  type="button"
                                  disabled={this.state.savingBrand || (this.state.tradingName || '').trim() === (this.state.tradingNameSaved || '').trim()}
                                  onClick={() => this.setState({ confirmingBrand: true })}
                                  style={(this.state.savingBrand || (this.state.tradingName || '').trim() === (this.state.tradingNameSaved || '').trim()) ? { opacity: 0.45, cursor: 'default' } : undefined}
                              >
                                  {this.state.savingBrand ? 'Saving…' : 'Save'}
                              </button>
                          </div>
                          {this.state.slugPreview && !this.state.confirmingBrand && (
                              <p className="bu-hint" style={{ marginTop: 6, marginBottom: 0 }}>
                                  Your link will be <strong>…/book/pro/{this.state.slugPreview}</strong>
                                  {this.state.slugPreviewTaken && (
                                      <span style={{ color: '#B54708' }}>. That name is already taken nearby, so yours gets a number added</span>
                                  )}
                              </p>
                          )}
                          {this.state.confirmingBrand && (
                              <div className="bu-confirm">
                                  <p className="bu-confirm-text">
                                      {this.state.slugPreview
                                          ? <>Your link will change to <strong>…/book/pro/{this.state.slugPreview}</strong>. Your current link keeps working and still brings clients to you.</>
                                          : <>This updates your page name and may change your link. Your current link keeps working.</>}
                                  </p>
                                  <div className="bu-inline-actions bu-confirm-actions">
                                      <button type="button" className="bu-inline-cancel" onClick={() => this.setState({ confirmingBrand: false })} disabled={this.state.savingBrand}>
                                          Cancel
                                      </button>
                                      <button type="button" className="bu-inline-save" onClick={this.saveBrand} disabled={this.state.savingBrand}>
                                          {this.state.savingBrand ? 'Saving…' : 'Confirm change'}
                                      </button>
                                  </div>
                              </div>
                          )}
                          {this.state.proPrevSlug && !this.state.confirmingBrand && (
                              <p className="bu-hint" style={{ marginTop: 8, marginBottom: 0 }}>
                                  Changed your mind?{' '}
                                  <button type="button" onClick={this.revertProSlug} disabled={this.state.revertingPro}
                                      style={{ background: 'none', border: 'none', padding: 0, color: '#007EA0', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}>
                                      {this.state.revertingPro ? 'Reverting…' : `Revert to …/book/pro/${this.state.proPrevSlug}`}
                                  </button>
                              </p>
                          )}
                      </div>
                      <p className="bu-hint" style={{ marginTop: 12 }}>
                          {this.proBookingUrl()
                              ? 'Your booking link below updates to match. Your diary, clients and payments are not affected, and the address still shows on your page.'
                              : "We're setting your link up now. Refresh in a moment if it hasn't appeared below."}
                      </p>
                      </>
                  )}
              </div>
          )}

          {/* Booking Link */}
          <div className="settings-card">
              <div className="settings-card-header" style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <div>
                      <h2>Booking Link</h2>
                      <p>Share this link on your website, social media and marketing to take bookings online.</p>
                  </div>
                  <ApplyToAllLocations area="booking" label="booking" />
              </div>

              <div className="bu-clipboard">
                  <input
                      type="text"
                      value={this.primaryBookingUrl()}
                      onClick={this.clip.bind(this)}
                      readOnly
                  />
                  <button
                      className={this.state.isCopyText ? 'copied' : ''}
                      type="button"
                      onClick={() => this.copyUrl(this.primaryBookingUrl())}
                  >
                      {this.state.isCopyText ? 'Copied' : 'Copy'}
                  </button>
              </div>

              {/* Owners can rename the salon's link. Preview before anything
                  is written, explicit confirm, and a one-click revert — the
                  old link keeps resolving either way. */}
              {this.isSalonOwner() && !this.state.salonLinkEditing && (
                  <p className="bu-hint" style={{ marginTop: 4 }}>
                      <button type="button"
                          onClick={() => this.setState({ salonLinkEditing: true, salonLinkName: '', salonLinkPreview: null, salonLinkPreviewTaken: false, confirmingSalonLink: false })}
                          style={{ background: 'none', border: 'none', padding: 0, color: '#007EA0', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}>
                          Change link
                      </button>
                      {this.state.salonPrevSlug && (
                          <>
                              {'  ·  '}
                              <button type="button" onClick={this.revertSalonLink} disabled={this.state.revertingSalon}
                                  style={{ background: 'none', border: 'none', padding: 0, color: '#007EA0', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}>
                                  {this.state.revertingSalon ? 'Reverting…' : `Revert to …/book/${this.state.salonPrevSlug}`}
                              </button>
                          </>
                      )}
                  </p>
              )}
              {this.isSalonOwner() && this.state.salonLinkEditing && (
                  <div style={{ marginTop: 10 }}>
                      <p className="bu-hint" style={{ marginTop: 0, marginBottom: 8 }}>
                          Enter the name for your link. Your area is added automatically, and your current link keeps working.
                      </p>
                      <div className="bu-clipboard" style={{ marginBottom: 0 }}>
                          <input
                              type="text"
                              value={this.state.salonLinkName}
                              maxLength={80}
                              placeholder={this.state.salonName || 'Your business name'}
                              onChange={(e) => { this.setState({ salonLinkName: e.target.value, confirmingSalonLink: false }); this.previewSalonLink(e.target.value); }}
                              style={{ background: '#fff', color: '#333' }}
                          />
                          <button type="button"
                              disabled={this.state.savingSalonLink || !(this.state.salonLinkName || '').trim()}
                              onClick={() => this.setState({ confirmingSalonLink: true })}
                              style={(this.state.savingSalonLink || !(this.state.salonLinkName || '').trim()) ? { opacity: 0.45, cursor: 'default' } : undefined}>
                              Save
                          </button>
                      </div>
                      {this.state.salonLinkPreview && !this.state.confirmingSalonLink && (
                          <p className="bu-hint" style={{ marginTop: 6, marginBottom: 0 }}>
                              Your link will be <strong>…/book/{this.state.salonLinkPreview}</strong>
                              {this.state.salonLinkPreviewTaken && (
                                  <span style={{ color: '#B54708' }}>. That name is already taken nearby, so yours gets a number added</span>
                              )}
                          </p>
                      )}
                      {this.state.confirmingSalonLink && (
                          <div className="bu-confirm">
                              <p className="bu-confirm-text">
                                  Your booking link will change to <strong>…/book/{this.state.salonLinkPreview || '…'}</strong>.
                                  Your current link keeps working and still brings clients to you.
                              </p>
                              <div className="bu-inline-actions bu-confirm-actions">
                                  <button type="button" className="bu-inline-cancel" onClick={() => this.setState({ confirmingSalonLink: false })} disabled={this.state.savingSalonLink}>
                                      Cancel
                                  </button>
                                  <button type="button" className="bu-inline-save" onClick={this.saveSalonLink} disabled={this.state.savingSalonLink}>
                                      {this.state.savingSalonLink ? 'Saving…' : 'Confirm change'}
                                  </button>
                              </div>
                          </div>
                      )}
                      <p className="bu-hint" style={{ marginTop: 8, marginBottom: 0 }}>
                          <button type="button"
                              onClick={() => this.setState({ salonLinkEditing: false, confirmingSalonLink: false, salonLinkName: '', salonLinkPreview: null })}
                              style={{ background: 'none', border: 'none', padding: 0, color: '#888', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}>
                              Close
                          </button>
                      </p>
                  </div>
              )}

              <BookingQr url={this.primaryBookingUrl()} name={this.state.salonName} />

              {/* Sits ABOVE Marketplace because it overrides it: with this off
                  there are no online bookings from anywhere, listing or not. */}
              <div className="bu-toggle-row">
                  <div className="bu-toggle-text">
                      <span>Accept online bookings</span>
                      <span className="bu-hint">
                          {this.isSalonOwner()
                              ? 'Turn off to stop taking online bookings for everyone'
                              : 'Turn off to stop taking online bookings for yourself'}
                      </span>
                  </div>
                  {/* Deliberately NOT behind checkReadOnly(): that helper means
                      "is a salon owner", which is the right gate for the
                      salon-level Marketplace toggle below but the wrong one
                      here. A self-employed stylist sets their OWN switch, so
                      every professional can use this row. */}
                  <button
                      className={`ds-toggle${this.state.onlineBookingEnabled ? ' ds-toggle--on' : ''}`}
                      onClick={this.toggleOnlineBooking}
                      type="button"
                  >
                      <span className="ds-toggle-knob" />
                  </button>
              </div>

              {/* Two different listings share this row depending on who's
                  looking. An owner controls the SALON's marketplace entry. A
                  professional controls their OWN entry, which links to their
                  page rather than the salon's — so it stays theirs to set even
                  though the salon listing isn't. */}
              <div className="bu-toggle-row">
                  <div className="bu-toggle-text">
                      <span>Beu Marketplace</span>
                      <span className="bu-hint">
                          {!this.isSalonOwner()
                              ? 'Clients can discover you in the Beu app and book you directly'
                              : !this.state.onlineBookingEnabled
                                  ? 'Unavailable while online bookings are turned off'
                                  : 'Clients can discover and book through the Beu app'}
                      </span>
                  </div>
                  {this.isSalonOwner() ? (
                      <button
                          className={`ds-toggle${this.state.isShow && this.state.onlineBookingEnabled ? ' ds-toggle--on' : ''}${!this.state.onlineBookingEnabled ? ' ds-toggle--disabled' : ''}`}
                          onClick={this.state.onlineBookingEnabled ? this.toggleChange : undefined}
                          type="button"
                          disabled={!this.state.onlineBookingEnabled}
                          aria-disabled={!this.state.onlineBookingEnabled}
                      >
                          <span className="ds-toggle-knob" />
                      </button>
                  ) : (
                      <button
                          className={`ds-toggle${this.state.showOnMarketplace && this.state.onlineBookingEnabled ? ' ds-toggle--on' : ''}${!this.state.onlineBookingEnabled ? ' ds-toggle--disabled' : ''}`}
                          onClick={this.state.onlineBookingEnabled ? this.toggleMarketplaceListing : undefined}
                          type="button"
                          disabled={!this.state.onlineBookingEnabled}
                          aria-disabled={!this.state.onlineBookingEnabled}
                      >
                          <span className="ds-toggle-knob" />
                      </button>
                  )}
              </div>
          </div>

          {/* Guest bookings: its own card so the two guest switches read as
              one setting with a sub-option, not as more rows under the link. */}
          <div className="settings-card">
              <div className="settings-card-header">
                  <h2>Guest Bookings</h2>
                  <p>Let clients book without a Beu account</p>
              </div>
              {/* Guest bookings: clients book without creating an account. Pay
                  at salon only, so it needs online booking on to mean anything.
                  Like the master switch, every professional sets their own. */}
              <div className="bu-toggle-row">
                  <div className="bu-toggle-text">
                      <span>Allow guest bookings</span>
                      <span className="bu-hint">
                          {!this.state.onlineBookingEnabled
                              ? 'Unavailable while online bookings are turned off'
                              : 'Clients can book without creating an account. They verify by email and can pay a deposit or save a card, just like signed-in clients.'}
                      </span>
                  </div>
                  <button
                      className={`ds-toggle${this.state.allowGuestBooking && this.state.onlineBookingEnabled ? ' ds-toggle--on' : ''}${!this.state.onlineBookingEnabled ? ' ds-toggle--disabled' : ''}`}
                      onClick={this.state.onlineBookingEnabled ? this.toggleGuestBooking : undefined}
                      type="button"
                      disabled={!this.state.onlineBookingEnabled}
                      aria-disabled={!this.state.onlineBookingEnabled}
                  >
                      <span className="ds-toggle-knob" />
                  </button>
              </div>

              {/* OTP on guest checkout — salon-level, owner-only. On by
                  default; switching it off is the salon's friction trade-off.
                  Guests whose email already has a Beu account still get the
                  sign-in code either way. */}
              {(
                  <div className="bu-toggle-row">
                      <div className="bu-toggle-text">
                          <span>Guests verify with a code</span>
                          <span className="bu-hint">
                              {!(this.state.onlineBookingEnabled && this.state.allowGuestBooking)
                                  ? 'Applies when guest bookings are turned on'
                                  : (this.isSalonOwner()
                                      ? 'Guests confirm a code sent to their email before booking with you or your employed team — self-employed staff set their own. Turning this off removes the step; anyone using an email that already has a Beu account is still asked to sign in.'
                                      : 'Guests confirm a code sent to their email before booking with you. Turning this off removes the step; anyone using an email that already has a Beu account is still asked to sign in.')}
                          </span>
                      </div>
                      <button
                          className={`ds-toggle${this.state.guestBookingOtpRequired && this.state.allowGuestBooking && this.state.onlineBookingEnabled ? ' ds-toggle--on' : ''}${!(this.state.onlineBookingEnabled && this.state.allowGuestBooking) ? ' ds-toggle--disabled' : ''}`}
                          onClick={this.state.onlineBookingEnabled && this.state.allowGuestBooking ? this.toggleGuestOtp : undefined}
                          type="button"
                          disabled={!(this.state.onlineBookingEnabled && this.state.allowGuestBooking)}
                          aria-disabled={!(this.state.onlineBookingEnabled && this.state.allowGuestBooking)}
                      >
                          <span className="ds-toggle-knob" />
                      </button>
                  </div>
              )}
          </div>

          {/* No Show and Cancellation */}
          <div className="settings-card">
              <div className="settings-card-header">
                  <h2>No Show and Cancellation</h2>
                  <p>Charge fees when clients cancel late or don't show up.</p>
              </div>

              {/* No show toggle + inline fee */}
              <div className="bu-toggle-row">
                  <div className="bu-toggle-text">
                      <span>No show protection</span>
                      <span className="bu-hint">Charge clients who don't show up</span>
                  </div>
                  <div className="bu-toggle-controls">
                      {this.state.noShowProtectionStatus && (
                          <div className="bu-inline-fee">
                              <input
                                  type="number"
                                  className={this.state.noShowProtectionFeeError ? 'bu-fee-error' : ''}
                                  value={this.state.noShowProtectionFeePercentage}
                                  onChange={(e) => this.onChangeProtectionFee("percentage", e.target.value)}
                                  onBlur={() => this.onBlurProtectionFee()}
                              />
                              <span>%</span>
                          </div>
                      )}
                      <button
                          className={`ds-toggle${this.state.noShowProtectionStatus ? ' ds-toggle--on' : ''}`}
                          onClick={() => this.onChangeProtectionFee("status", !this.state.noShowProtectionStatus)}
                          type="button"
                      >
                          <span className="ds-toggle-knob" />
                      </button>
                  </div>
              </div>

              {/* Cancellation thresholds */}
              {this.state.cancellationPolicies?.length > 0 && (
                  <>
                      <div className="bu-threshold-header">
                          <span>Cancellation window</span>
                          <span>Fee</span>
                      </div>
                      {this.state.cancellationPolicies.map((policy, i) => (
                          <div className="bu-threshold-row" key={"_treshold_" + i}>
                              <div className="bu-threshold-select settings-select-wrapper">
                                  <Select
                                      options={this.state.cancellationOptions}
                                      value={policy?.selectedOption?.value ? policy?.selectedOption : null}
                                      placeholder="Select window..."
                                      styles={selectStyles}
                                      className={policy?.selectedOption?.value == undefined && policy?.errorStatus ? 'settings-input-error' : ''}
                                      onChange={(e) => this.onChangePolicy(policy, e, "cancellationPolicySelect")}
                                  />
                              </div>
                              <div className="bu-inline-fee">
                                  <input
                                      type="number"
                                      className={policy?.errorStatus ? 'bu-fee-error' : ''}
                                      value={policy?.amountInPercentage}
                                      onChange={(e) => this.onChangePolicy(policy, e, "cancellationPolicy")}
                                  />
                                  <span>%</span>
                              </div>
                              <button type="button" className="bu-remove-btn" onClick={() => this.deleteCancellationPolicy(policy)}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                              </button>
                          </div>
                      ))}
                  </>
              )}

              <button className="bu-add-btn" onClick={() => this.addCancellationRow()} type="button">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  Add cancellation threshold
              </button>

              {hasCancellationChanges && (
                  <div className="bu-inline-actions">
                      <button className="bu-inline-cancel" onClick={() => this.resetCancellationChanges()} type="button">Cancel</button>
                      <button className="bu-inline-save" onClick={() => this.updateCancellationPolicy()} type="button">Save</button>
                  </div>
              )}
          </div>

          {/* Reschedule policy — same approach as no-show/cancellation:
              per-professional, autosaved. Off = clients can't move bookings
              online at all (the pre-feature behaviour). */}
          <div className="settings-card">
              <div className="settings-card-header">
                  <h2>Reschedule</h2>
                  <p>Let clients move their own bookings online, up to a cut-off before the appointment.</p>
              </div>

              <div className="bu-toggle-row">
                  <div className="bu-toggle-text">
                      <span>Client rescheduling</span>
                      <span className="bu-hint">Clients can move a booking themselves until the cut-off. After that they need to contact you</span>
                  </div>
                  <div className="bu-toggle-controls">
                      <button
                          className={`ds-toggle${this.state.rescheduleStatus ? ' ds-toggle--on' : ''}`}
                          onClick={() => this.setState({ rescheduleStatus: !this.state.rescheduleStatus }, () => this.autoSavePolicies())}
                          type="button"
                      >
                          <span className="ds-toggle-knob" />
                      </button>
                  </div>
              </div>
              {/* The cut-off picker gets its own row — inline it crushed the
                  label into a word-per-line column on mobile. */}
              {this.state.rescheduleStatus && (
                  <>
                      <div className="bu-threshold-header">
                          <span>Reschedule window</span>
                      </div>
                      <div className="bu-threshold-row">
                          <div className="bu-threshold-select settings-select-wrapper" style={{ flex: 1, maxWidth: 320 }}>
                              <Select
                                  options={this.state.rescheduleOptions}
                                  value={this.state.rescheduleBeforeHours}
                                  styles={selectStyles}
                                  onChange={(e) => this.setState({ rescheduleBeforeHours: e }, () => this.autoSavePolicies())}
                              />
                          </div>
                      </div>
                  </>
              )}
          </div>

          {/* No Show Fee - owner only */}
          {this.checkReadOnly() && (
              <div className="settings-card">
                  <div className="settings-card-header">
                      <h2>No Show Fee</h2>
                      <p>A fee of 1.25% + 20p applies per online booking with no show enabled. This fee is waived for any booking where payment is processed through Beu.</p>
                  </div>

                  <div className={`bu-radio${this.state.noShowFeeChargeBy === 1 ? ' bu-radio--selected' : ''}`} onClick={() => this.noChangePaidBy(1)}>
                      <div className="bu-radio-dot"><div /></div>
                      <span>Self employed pays</span>
                  </div>
                  <div className={`bu-radio${this.state.noShowFeeChargeBy === 2 ? ' bu-radio--selected' : ''}`} onClick={() => this.noChangePaidBy(2)}>
                      <div className="bu-radio-dot"><div /></div>
                      <span>The business pays</span>
                  </div>
              </div>
          )}

          {/* Booking Window */}
          <div className="settings-card">
              <div className="settings-card-header">
                  <h2>Booking Window</h2>
                  <p>Control how early or late clients can book online.</p>
              </div>

              <div className="bu-select-row settings-select-wrapper">
                  <label>Cutoff before appointment</label>
                  <Select
                      menuPlacement="top"
                      styles={selectStyles}
                      options={this.state.onlineBookingUptoBeforeOptions}
                      value={this.state.onlineBookingUptoBefore}
                      onChange={(e) => this.onChangeSetting(e, "onlineBookingUptoBefore")}
                  />
              </div>
              <div className="bu-select-row settings-select-wrapper">
                  <label>Furthest in advance</label>
                  <Select
                      menuPlacement="top"
                      styles={selectStyles}
                      options={this.state.onlineBookingUptoOptions}
                      value={this.state.onlineBookingUpto}
                      onChange={(e) => this.onChangeSetting(e, "onlineBookingUpto")}
                  />
              </div>
          </div>

      </SettingsPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(mapStateToProps)(BookingUrl);
